import { f as n } from "./index758.mjs";
import { w as t } from "./index760.mjs";
import { e } from "./index819.mjs";
var s = n, i = t, f = e, c = i("species"), p = function(o) {
  return f >= 51 || !s(function() {
    var r = [], a = r.constructor = {};
    return a[c] = function() {
      return { foo: 1 };
    }, r[o](Boolean).foo !== 1;
  });
};
export {
  p as a
};
